export default __webpack_public_path__ + "static/media/icon-file-xls-empty.558bba31.svg";